module.exports = __webpack_public_path__ + "img/tyche.ac0def4b.png";